import React from "react";
import { MenuItem, TextField } from "@mui/material";
import { FISCALIZATION_AWAITING, FISCALIZATION_ERROR, FISCALIZATION_NOT_FISCALIZED, FISCALIZATION_SUCCESS } from "../../utils/listitem";
import { useTranslation } from "react-i18next";


const FiscalizationStateSelect = (props) => {
    const { t } = useTranslation();
    return <TextField {...props} label={t('FISCALIZATION_STATE')} select>
        <MenuItem value={""}>{t("ALL")}</MenuItem>
        <MenuItem value={FISCALIZATION_AWAITING}>{t(FISCALIZATION_AWAITING)}</MenuItem>
        <MenuItem value={FISCALIZATION_SUCCESS}>{t(FISCALIZATION_SUCCESS)}</MenuItem>
        <MenuItem value={FISCALIZATION_ERROR}>{t(FISCALIZATION_ERROR)}</MenuItem>
        <MenuItem value={FISCALIZATION_NOT_FISCALIZED}>{t(FISCALIZATION_NOT_FISCALIZED)}</MenuItem>
    </TextField>;
}

export default FiscalizationStateSelect;
